<template>
  <div class="report-footprint"
    :class="getReportType">
    <div class="report-footprint__content">
     <div class="report-footprint__chart"
      v-if="theSample.becrop_report != null && theSample.c_estado == 3">
       <div class="rep__row biosust__row">
         <span :class="getMyRankClass(theSample.becrop_report.biodiversity_rank)"></span>
         <span :class="getMyRankClass(theSample.becrop_report.functionality_rank)"></span>
         <span :class="getMyRankClass(theSample.becrop_report.resistance_rank)"></span>
       </div>
       <div class="rep__row health__row">
         <span :class="getMyRankClass(theSample.becrop_report.healthiness_rank)"></span>
         <span :class="getMyRankClass(theSample.becrop_report.biocontrol_rank)"></span>
         <span :class="getMyRankClass(theSample.becrop_report.hormoneprod_rank)"></span>
         <span :class="getMyRankClass(theSample.becrop_report.stressadapt_rank)"></span>
       </div>
       <div class="rep__row nutrit__row">
         <span :class="getMyRankClass(theSample.becrop_report.nutrition_c_rank)"></span>
         <span :class="getMyRankClass(theSample.becrop_report.nutrition_n_rank)"></span>
         <span :class="getMyRankClass(theSample.becrop_report.nutrition_p_rank)"></span>
         <span :class="getMyRankClass(theSample.becrop_report.nutrition_k_rank)"></span>
       </div>
     </div>
     <div v-else class="report-footprint__chart is--ghost">
      <div class="rep__row biosust__row">
         <span></span>
         <span></span>
         <span></span>
      </div>
      <div class="rep__row health__row">
         <span></span>
         <span></span>
         <span></span>
         <span></span>
      </div>
      <div class="rep__row nutrit__row">
         <span></span>
         <span></span>
         <span></span>
         <span></span>
      </div>
     </div>
    </div>
  </div>
</template>

<script>
export default {
  /*
    TYPE PROP: 0 FOR BECROP | 1 FOR GHEOM
  */ 
  name: "",
  props: [
    "theSample", "type"
  ],
  data:function(){ 
    return {
      rank_classes: ["val--vl", "val--l", "val--m", "val--h", "val--vh"],
      rep_type_classes: ["is--becrop", "is--gheom"]
    }
  },
  computed: {
    getReportType: function() {
      return this.rep_type_classes[this.type]; 
    },

  },
  methods: {
    getMyRankClass(rank) {
      return this.rank_classes[rank-1];
    }
  }
}
</script>

